import axiosInstance from '../Config/AxiosInstance';
const PREFIX = `/clinic/patient`;
export const getDataOfPatient = (facilityId, patientId) => {
  return axiosInstance.get(
    PREFIX + `?facilityId=${facilityId}&patientId=${patientId}`
  );
};
export const getADTRecord = (facilityId, patientId) => {
  return axiosInstance.get(
    PREFIX + `/adt-records?facilityId=${facilityId}&patientId=${patientId}`
  );
};
export const getContacts = (facilityId, patientId) => {
  return axiosInstance.get(
    PREFIX + `/contacts?facilityId=${facilityId}&patientId=${patientId}`
  );
};
export const getCoverages = (facilityId, patientId, effectiveDateTime) => {
  let url = PREFIX + `/coverages?facilityId=${facilityId}&patientId=${patientId}`;
  if (effectiveDateTime) url += `&effectiveDateTime=${effectiveDateTime}`;
  return axiosInstance.get(url);
};

export const getAllergyIntoleranceData = (facilityId, patientId) => {
  return axiosInstance.get(
    PREFIX +
      `/allergy-intolerances?facilityId=${facilityId}&patientId=${patientId}`
  );
};
export const getAdvanceDirectivesConsentsData = (facilityId, patientId) => {
  return axiosInstance.get(
    PREFIX + `/consents?facilityId=${facilityId}&patientId=${patientId}`
  );
};
export const getPractitionersData = (facilityId, patientId) => {
  return axiosInstance.get(
    PREFIX + `/practitioners?facilityId=${facilityId}&patientId=${patientId}`
  );
};

export const getPatientObservations = (facilityId, patientId) => {
  return axiosInstance.get(
    PREFIX + `/observations?facilityId=${facilityId}&patientId=${patientId}`
  );
};

export const getPatientConditions = (facilityId, patientId) => {
  return axiosInstance.get(
    PREFIX + `/conditions?facilityId=${facilityId}&patientId=${patientId}`
  );
};
